import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  // State to toggle the megamenu for "Vertical Solutions"
  const [isMegaMenuOpen, setIsMegaMenuOpen] = useState(false);
  const megamenuRef = useRef(null);
  const megamenuRef2 = useRef(null);

  const navigate = useNavigate(); // useNavigate hook

  const toggleMegaMenu = () => {
    setIsMegaMenuOpen(!isMegaMenuOpen);
  };

  const closeMegaMenu = () => {
    setIsMegaMenuOpen(false);
  };

  // Handle closing the megamenu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (megamenuRef.current && !megamenuRef.current.contains(event.target)) {
        closeMegaMenu(); // Close the megamenu if clicked outside
      }
    };

    // Add event listener to the document
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [megamenuRef]);

  const menuRight = useRef(null);
  const toast = useRef(null);
  const items = [
    {
      items: [
        {
          label: "Home",
          command: () => navigate("/"), // Yönlendirme için command kullanıyoruz
        },
      ],
    },
    {
      label: "Vertical Solutions",
      items: [
        {
          label: "Item 1",
          command: () => navigate("/single-vertical"),
        },
        {
          label: "Item 2",
          command: () => navigate("/vertical-solutions/item2"),
        },

        {
          label: "Item 3",
          command: () => navigate("/vertical-solutions/item3"),
        },

        {
          label: "Item 4",
          command: () => navigate("/vertical-solutions/item4"),
        },

        {
          label: "Item 5",
          command: () => navigate("/vertical-solutions/item5"),
        },

        {
          label: "Item 6",
          command: () => navigate("/vertical-solutions/item6"),
        },

        {
          label: "General Info Page",
          command: () => navigate("/vertical-solutions"),
        },
      ],
    },
    {
      items: [
        {
          label: "Connectivity",
          command: () => navigate("/connectivity"),
        },
      ],
    },
    {
      items: [
        {
          label: "Use Cases",
          command: () => navigate("/use-cases"),
        },
      ],
    },
    {
      items: [
        {
          label: "Partners",
          command: () => navigate("/partners"),
        },
      ],
    },
    {
      items: [
        {
          label: "Blog",
          command: () => navigate("/blog-page"),
        },
      ],
    },
    {
      items: [
        {
          label: "FAQ",
          command: () => navigate("/faq"),
        },
      ],
    },
    {
      items: [
        {
          label: "Contact Us",
          command: () => navigate("/contact-us"),
        },
      ],
    },
  ];

  return (
    <div className="wrapper-navbar">
      <div className="navbar-container">
        <div className="logo-container">
          <Link to="/">
            <img id="logo-img" src="/PNG-01.png" alt="logo" />
          </Link>
        </div>
        <div className="navbar-list">
          <ul>
            <li className="navbar-li">
              <button>
                <Link to="/vertical-solutions">Vertical Solutions</Link>
              </button>
            </li>

            <li className="navbar-li">
              <button>
                <Link to="/connectivity">Connectivity</Link>
              </button>
            </li>
            <li className="navbar-li">
              <button>
                <Link to="/connectivity-form">Get Quote</Link>
              </button>
            </li>
            <li className="navbar-li">
              <button>
                <Link to="/partners">Partners</Link>
              </button>
            </li>
            <li className="navbar-li">
              <button>
                <Link to="/blog-page">Blog</Link>
              </button>
            </li>
            <li className="navbar-li">
              <button>
                <Link to="/faq">FAQ</Link>
              </button>
            </li>
            <li className="navbar-li">
              <button>
                <Link to="/contact-us">Contact</Link>
              </button>
            </li>
          </ul>
        </div>

        <div className="mobile-navbar">
          <Toast ref={toast}></Toast>

          <Menu
            model={items}
            popup
            ref={menuRight}
            id="popup_menu_right"
            popupAlignment="right"
          />
          <Button
            label="Menu"
            icon="pi pi-align-right"
            className="mr-2"
            onClick={(event) => menuRight.current.toggle(event)}
            aria-controls="popup_menu_right"
            aria-haspopup
          />
        </div>
      </div>
    </div>
  );
}
